import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import { packageData } from "@/mixins/index";
import uploadAPK from '@/components/uploadAPK';
import util from '@/libs/util';
import axios from 'axios';
export default {
  mixins: [popUp, packageData],
  components: {
    uploadAPK: uploadAPK
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      reqLoading: false,
      formData: {
        id: "",
        desc: "",
        url: ''
      },
      formDataParams: null,
      isReWrite: false,
      formDataPrimitive: {},
      formDataMake: {},
      imgList: [],
      rules: {
        desc: [{
          required: true,
          message: "请输入图片描述",
          trigger: "blur"
        }],
        url: [{
          required: true,
          message: "请上传图片",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // this.imgList = [];
                _this.copyPrimitive();

                if (data) {
                  datas = JSON.parse(JSON.stringify(data));
                  _this.formData = _objectSpread({}, datas);
                  _this.imgList = [datas.url];
                }

                _this.copyData();

                _this.isReWrite = true;
                _this.dialogFormVisible = true;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    imgChange: function imgChange(e) {
      console.log("e====", e);
      this.imgList = e;
      this.formData.url = e[0] && e[0].response ? e[0].response.data : '';
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.imgList = isClear ? [] : this.formDataMake.url ? [this.formDataMake.url] : [];
      this.isReWrite = true;
      this.clearData(isClear);
    },
    clearData: function clearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.isReWrite = false;
      this.imgList = [];
      this.formData = JSON.parse(JSON.stringify(isClear ? this.formDataPrimitive : this.formDataMake));
      this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (valid) {
                    _this2.reqLoading = true;
                    reqFn = _this2.formData.id ? 'iconUpdate' : 'iconAdd';

                    _this2.$api[reqFn](_this2.formData).then(function (res) {
                      if (res.status == 200) {
                        _this2.$message({
                          message: '添加成功',
                          type: 'success'
                        });

                        _this2.dialogFormVisible = false;

                        _this2.$emit('change');
                      }
                    }).finally(function () {
                      _this2.reqLoading = false;
                    });
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};